import { Component, OnInit, OnChanges, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AppConfig } from '../../../app.config';
import { SharedService } from '../../services/shared.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.css']
})
export class ImageUploadComponent implements OnInit, OnChanges {
  @Input() imageId: string;
  @Input() isImageType: boolean;
  @Input() savingFilePath: string;
  @Input() isShowDropzone: boolean;
  @Output() imageIdChange = new EventEmitter<string>();
  @Output() fileSavedChange = new EventEmitter();
  getUrl = AppConfig.settings.api.url + '/image/getimage';
  postUrl = AppConfig.settings.api.url + '/image/postimage';
  authHeaders: any;
  uploadImage: boolean;


  isEdit = true;
  entityId: string;
  fileName: string;
  // @Output() uploadedListChange= new EventEmitter<Object[]>() ;
  @Output() uploadedList: Array<object> = [];
  constructor(
    private sharedService: SharedService,
    private route: ActivatedRoute,
    private toastr: ToastrService,
  ) {
    //debugger;
    this.entityId = this.route.snapshot.paramMap.get('id');
    if (this.entityId == null) {
      this.isEdit = false;
    }
  }

  ngOnInit() {
    this.authHeaders = this.sharedService.authHeader();
    this.uploadImage = this.imageId ? false : true;
  }

  ngOnChanges(changes) {
    if (changes.imageId && JSON.stringify(changes.imageId.previousValue) !== JSON.stringify(changes.imageId.currentValue)) {
      this.uploadImage = this.imageId ? false : true;
    }
  }

  editImage() {
    this.uploadImage = true;
  }

  cancelUpload() {
   // debugger;
    this.uploadImage = false;
  }

  showDropzone(){
    this.uploadImage = true;
  }

  fileUploaded(e: any) {
    debugger;
    console.log(e.file.name);
    // this.uploadImage = false;
    this.imageId = e.response;
    this.fileName = e.file.name;

    var uploadedObj = {
      "EntityId": this.entityId,
      "FileId": this.imageId,
      "FileName": this.fileName
    };
    // this.uploadedList.push(uploadedObj)
    // this.imageIdsList.push(this.imageId);
    // console.log(this.imageIdsList); 
    if (this.entityId) {
      this.saveFile(uploadedObj);
    }

    // let filetype = e.file.type.toString();
    // console.log(filetype);
    // if (filetype.includes('image')) {
    //   console.log('is image');
    if (this.isImageType) {
      this.imageIdChange.emit(this.imageId);
    }
    //}
  }

  saveFile(uploadedObj: object) {
   // debugger;
    this.sharedService.post<object>(uploadedObj, `${this.savingFilePath}`, true)
      .subscribe(
        res => {
          console.log(res);
          //  this.uploadImage = true;
          this.fileSavedChange.emit();
        },
        err => {
          //debugger;
          console.log("file saving failed");
          console.log(err);
          this.toastr.error('هناك خطأ فى حفظ الملف', 'خطأ !!');
        }
      )
  }

  uploadFailed(e: any) {
    console.log(e);
  }
}
